import { PerkDefinition } from "./types";

/**
 * Multi-Attack perk - Boss attacks twice per turn.
 * This is a reactive perk that modifies combat behavior during the attack phase.
 * Note: Actual multi-attack logic would need to be implemented in the combat engine.
 * For now, this is a placeholder that increases attack power to simulate multiple attacks.
 */
export const perkMultiAttack = {
  id: "perk_multi_attack",
  name: "Multi-Attack",
  description: "Attacks twice per turn.",
  apply: (context) => {
    // Increase attack power to simulate attacking twice
    // This is a simplified implementation - full multi-attack would require combat engine changes
    context.addAttack(2);
  },
} satisfies PerkDefinition<"perk_multi_attack">;
